import { REGEX_INDEXED_LEGAL } from './constants';
/**
 * Searches the input string and returns an array of slugs
 * corresponding to indexed legals.
 *
 * @param str Input string.
 * @returns An array of indexed legal slugs.
 */
export default function findIndexedLegals(str) {
    const matches = [...str.matchAll(REGEX_INDEXED_LEGAL)];
    return matches.map((match) => match[2]);
}
